import { getEnabledWallets, getChainInfo } from '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import 'react/jsx-runtime';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { createWallet } from '../../shared/utils/functions/wallet/createWallet.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';

const getEnabledChains = (chains) => chains
    .filter(({ enabled }) => enabled)
    .map(({ name }) => { var _a; return (_a = getChainInfo(name)) === null || _a === void 0 ? void 0 : _a.symbol; })
    .filter((chain) => Boolean(chain));
const getEnabledCosmosNetworks = (chains) => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = chains.find(({ enabled, name }) => enabled && name === 'cosmos')) === null || _a === void 0 ? void 0 : _a.networks) === null || _b === void 0 ? void 0 : _b.filter(({ enabled }) => enabled)) === null || _c === void 0 ? void 0 : _c.map(({ networkId }) => networkId)) || [];
};
const createWallets = (props) => {
    var _a, _b, _c, _d;
    return getEnabledWallets({
        enabledChains: getEnabledChains(props.settings.chains),
        enabledNetworks: getEnabledCosmosNetworks(props.settings.chains),
        getSupportedWalletOpts: Object.assign(Object.assign({}, props.getSupportedWalletOpts), { isWalletConnectV2Enabled: ((_a = props.settings.sdk.walletConnect) === null || _a === void 0 ? void 0 : _a.v2Enabled) &&
                ((_b = props.settings.sdk.walletConnect) === null || _b === void 0 ? void 0 : _b.projectId)
                ? (_c = props.settings.sdk.walletConnect) === null || _c === void 0 ? void 0 : _c.v2Enabled
                : false, walletConnectProjectId: (_d = props.settings.sdk.walletConnect) === null || _d === void 0 ? void 0 : _d.projectId }),
        installed: props.installed,
    }).map(createWallet);
};
const getInstalledWallets = (settings, getSupportedWalletOpts) => createWallets({
    getSupportedWalletOpts,
    installed: true,
    settings,
});
const getNotInstalledWallets = (settings, getSupportedWalletOpts) => createWallets({
    getSupportedWalletOpts,
    installed: false,
    settings,
});

export { getEnabledChains, getEnabledCosmosNetworks, getInstalledWallets, getNotInstalledWallets };
